import { Link } from '@twistopayments/design-system/components/atoms/link'
import { Typography } from '@twistopayments/design-system/components/atoms/typography'

import type { MediaArticle } from '@twisto/api-cms'

import { StrapiMedia } from 'homepage/components/atoms'

import * as styles from './media-articles-list.styles'

export const MediaArticleListItem = ({
  id,
  image,
  date,
  title,
  path,
}: MediaArticle) => (
  <li key={id} css={styles.card}>
    <Link to={path}>
      <StrapiMedia {...image} css={styles.image} />

      <Typography css={styles.date} variant="b2">
        {date}
      </Typography>
      <Typography css={styles.title} fontWeight="heavy">
        {title}
      </Typography>
    </Link>
  </li>
)
